import styled from "styled-components"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import Btn from "../../shared/button/Btn"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { useDispatch } from "react-redux"
import { showModal } from "../../../features/modal/modalSlice"
import { useSelector } from "react-redux"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { regularDriverPhoneNumberQuery, setRegularDriverPhoneNumberQueryStatus } from "../../../features/driversVehicles/driversVehiclesSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 750px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 25px 0;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;

        .query-container{

            display: flex;
            gap: 15px;
            padding: 20px 40px;

            .err-text{
                color: var(--color-main);
                font-size: 13px;
                font-weight: var(--font-weight-md);
                padding-top: 10px;
            }
        }

        .btn-container{
            display: flex;
            gap: 30px;
        }

    }
`

const AddRegularDriverPhoneNumberQueryModal = () => {

    const dispatch = useDispatch()

    const {isLoadingRegularDriverPhoneNumberQuery, regularDriverPhoneNumberQueryStatus} = useSelector(state => state.driversVehicles)

    const [phoneNumber, setPhoneNumber] = useState("")

    const [isSubmit, setIsSubmit] = useState(false)

    const [isError, setIsError] = useState(false)

    useEffect(() => {
        dispatch(setRegularDriverPhoneNumberQueryStatus(null))
    },[phoneNumber])

    useEffect(() => {
        if(isSubmit){
            if(phoneNumber?.slice(2).length !== 10 || phoneNumber?.slice(2)[0] !== "5"){
                setIsError(true)
            }
            else{
                setIsError(false)
            }
        }
    },[isSubmit, phoneNumber])

    const handleSubmit = () => {
        setIsSubmit(true)
        if(phoneNumber?.slice(2).length === 10 && phoneNumber?.slice(2)[0] === "5"){
            dispatch(regularDriverPhoneNumberQuery(phoneNumber?.slice(2)))
        }
    } 



  return (
    <Container>
        <div className="modal">
            <PageTopTitle isDiffPage title={"Sürücü Ekle"}/>
            <div className="query-container">
                <div>
                    <InputPhoneFormat data={phoneNumber} setData={setPhoneNumber} labelText="Telefon Numarası" inputWidth={"280px"} name={"phoneNumber"}/>
                    {
                        isError && <p className="err-text">Lütfen geçerli bir telefon numarası girin</p>
                    }
                    {
                        regularDriverPhoneNumberQueryStatus === 1 &&
                        <p className="err-text">Bu Sürücü halihazırda zaten sürücülerinizde yer almaktadır.</p>
                    }
                </div>
                <Btn bgColor="var(--color-main)" color="#fff" width={"100px"} handleClick={handleSubmit} >{isLoadingRegularDriverPhoneNumberQuery ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Sorgula"}</Btn>
            </div>

            <div className="btn-container">
                <Btn bgColor="transparent" color="var(--color-main)" width={"140px"} handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </Container>
  )
}

export default AddRegularDriverPhoneNumberQueryModal